import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

import "./EmptyState.scss";
import Button from "components/v2/Button/Button";
import { ReactComponent as SpaceShip } from "assets/images/iconsV2/spaceship.svg";

export type EmptyStateProps = {
  /**
   * Title to show main text after icon in the empty state
   */
  title?: string;

  /**
   * description to show after the title
   */
  description?: string;

  /**
   * to pass a custom icon
   */
  customIcon?: React.ReactNode;

  /**
   * to pass custom action buttons
   */
  customActions?: React.ReactNode;

  /**
   * A boolean to completely remove action buttons
   */
  noActions?: boolean;
};

const EmptyState: FC<EmptyStateProps> = function (props) {
  const { title, description, customIcon, customActions, noActions } = props;
  const navigate = useNavigate();

  const handleRefreshClick = () => {
    navigate(0);
  };

  return (
    <div className="emptystate">
      <div>{customIcon || <SpaceShip />}</div>
      <div className="emptystate__title">{title}</div>
      <div className="emptystate__description">{description}</div>
      {!noActions && (
        <div className="emptystate__actions">
          {customActions || <Button label="Refresh page" variant="primary" onClick={handleRefreshClick} />}
        </div>
      )}
    </div>
  );
};

export default EmptyState;

EmptyState.defaultProps = {
  title: "Something went wrong",
  description: "We had some trouble loading this page. You can try again or check back later.",
  customIcon: undefined,
  customActions: undefined,
  noActions: false,
};
